<p-toast></p-toast>

<div class="my-hr-page-grid">
  <app-page-data-panel
    title="My documents"
    subtitle="Track verification and expiry without opening the HR admin document center."
    [resultText]="documents.length + ' documents'">
    @if (documents.length) {
      <p-table [value]="documents" responsiveLayout="stack" breakpoint="768px">
        <ng-template pTemplate="header">
          <tr>
            <th>Document</th>
            <th>Status</th>
            <th>Expiry</th>
            <th>File</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-document>
          <tr>
            <td>
              <span class="p-column-title">Document</span>
              <strong>{{ document.documentName || document.documentCode || 'Document' }}</strong>
              <div class="table-subtitle">{{ document.documentNumber || document.issuer || '-' }}</div>
            </td>
            <td><span class="p-column-title">Status</span><p-tag [value]="label(document.verificationStatus || document.complianceStatus)" [severity]="statusSeverity(document.verificationStatus || document.complianceStatus)"></p-tag></td>
            <td><span class="p-column-title">Expiry</span>{{ document.expiryDate | date:'mediumDate' }}</td>
            <td>
              <span class="p-column-title">File</span>
              @if (document.fileUrl) {
                <a [href]="document.fileUrl" target="_blank" rel="noopener">Open file</a>
              } @else {
                <span>-</span>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p class="empty-state">No HR documents are available yet.</p>
    }
  </app-page-data-panel>

  <app-page-form-section
    icon="fa-solid fa-upload"
    title="Upload document"
    subtitle="Submit document metadata and a file URL for HR verification.">
    <div class="form-grid">
      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-file"></i></p-inputgroup-addon>
        <p-iftalabel>
          <input id="documentCode" pInputText [(ngModel)]="documentForm.documentCode" />
          <label for="documentCode">Document code</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-id-card"></i></p-inputgroup-addon>
        <p-iftalabel>
          <input id="documentName" pInputText [(ngModel)]="documentForm.documentName" />
          <label for="documentName">Document name</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup class="form-span-2">
        <p-inputgroup-addon><i class="pi pi-link"></i></p-inputgroup-addon>
        <p-iftalabel>
          <input id="documentFileUrl" pInputText [(ngModel)]="documentForm.fileUrl" />
          <label for="documentFileUrl">File URL</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
        <p-iftalabel>
          <input id="documentNumber" pInputText [(ngModel)]="documentForm.documentNumber" />
          <label for="documentNumber">Document number</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
        <p-iftalabel>
          <input id="documentExpiryDate" pInputText [(ngModel)]="documentForm.expiryDate" />
          <label for="documentExpiryDate">Expiry date (YYYY-MM-DD)</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup class="form-span-2">
        <p-inputgroup-addon><i class="pi pi-comment"></i></p-inputgroup-addon>
        <p-iftalabel>
          <textarea id="documentNotes" pInputTextarea [(ngModel)]="documentForm.notes" rows="4"></textarea>
          <label for="documentNotes">Notes for HR review</label>
        </p-iftalabel>
      </p-inputgroup>
    </div>
    <div class="panel-actions-row">
      <button pButton type="button" label="Upload document" icon="pi pi-upload" [disabled]="!canManageSelf" [loading]="uploading" (click)="upload()"></button>
    </div>
  </app-page-form-section>
</div>
